const trackFormSubmissionForPixel = () => {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.PAID_EVENT,
    eventName: 'LeadSubmittedPixelTrigger',
  });
};

export default trackFormSubmissionForPixel;
